export const ApiTransferSpace = Symbol('ApiTransferSpace');
